import {Button, Chip, Grid, Typography} from "@material-ui/core";
import BoxWithImage from "../../../../../shared/components/box-with-image/BoxWithImage";
import calendarIcon from "../../../../../assets/images/icon-big-calendar-88-px.svg";
import React, {useEffect, useRef, useState} from "react";
import TabsDigitalContract from "./tabs/TabsDigitalContract";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import {useHistory, useParams} from "react-router-dom";
import * as actions from "../../../../../store";
import {useDispatch, useSelector} from "react-redux";
import {DigitalContractCardStyles} from "../digital-contract-card/DigitalContractCardStyles";
import {routePaths} from "../../../../../shared/utils/constants/routePaths";
import {formatMissingData} from "../../../../../shared/utils/formatDataUtils";
import {getRandomNumber} from "../../../../../shared/utils/utils";
import {Skeleton} from "@material-ui/lab";

const DigitalContractDetails = () => {
    const classes = DigitalContractCardStyles();

    const {digitalContractId} = useParams()
    const history = useHistory()
    const dispatch = useDispatch()

    const [selectedTab, setSelectedTab] = useState(0)

    const contractDetails = useSelector(state => state.contrattoDigitaleReducer.contractDetails)
    const selectedCompany = useSelector(state => state.authReducer.selectedCompany)
    const firstRender = useRef(true)
    const cacheLoading = useSelector((state) => state.authReducer.cacheDigitalContractLoading)

    const handleBackClick = () => {
        history.push(routePaths.CONTRATTO_DIGITALE);
    }

    const handleTabChange = (tab) => {
        setSelectedTab(tab)
    }

    useEffect(() => {
        if (!cacheLoading) {
            dispatch(actions.getContractDetailsData(digitalContractId));
            dispatch(actions.getContractTablesData(digitalContractId));
        }
    }, [dispatch, digitalContractId, cacheLoading])

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false
        } else {
            history.replace(routePaths.CONTRATTO_DIGITALE)
        }
    }, [history, selectedCompany])

    return (
        <Grid container
              spacing={3}>
            <Grid item
                  xs={12}>
                <Button color="primary"
                        onClick={handleBackClick}
                        variant="text"
                        startIcon={<ArrowBackIosIcon fontSize="small"/>}>
                    Indietro
                </Button>
            </Grid>

            <Grid item
                  xs={12}>
                <Typography variant="subtitle1">{contractDetails.loading || cacheLoading ?
                    <Skeleton animation='wave'
                              width={`${getRandomNumber(10, 30)}%`}/> :
                    formatMissingData(contractDetails.data.idCaption)}</Typography>
            </Grid>

            <Grid item container
                  spacing={3}
                  xs={12}>
                <Grid item
                      xs={12} sm={8} md={4}>
                    <BoxWithImage
                        title={"Data sottoscrizione"}
                        loading={contractDetails.loading || cacheLoading}
                        content={formatMissingData(contractDetails.data.dataSottoscrizioneDisplayValue)}
                        image={calendarIcon}/>
                </Grid>

                <Grid item container
                      xs={12} sm={4} md={4}
                      spacing={3}
                      justifyContent="space-between"
                      direction="column">
                    <Grid item>
                        {contractDetails.loading || cacheLoading ?
                            <Skeleton animation='wave'
                                      width={`${getRandomNumber(30, 60)}%`}/> :
                            <Typography
                                variant="caption">{formatMissingData(contractDetails.data.descrizione)}</Typography>}

                    </Grid>

                    <Grid item>
                        <Chip
                            label={contractDetails.loading || cacheLoading ?
                                <Skeleton animation='wave'
                                          width={`${getRandomNumber(80, 120)}px`}/> : contractDetails.data.changeInSelfCaption
                            }
                            className={classes.chipStyle}
                            color="primary"
                            size="small"/>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item
                  xs={12}>
                <TabsDigitalContract selectedTab={selectedTab}
                                     setSelectedTab={handleTabChange}/>
            </Grid>
        </Grid>
    )
}

export default DigitalContractDetails;
